import script from "./EntryList.vue?vue&type=script&setup=true&lang=js"
export * from "./EntryList.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__